import { getDecodedUserId } from '@ms/yammer-telemetry-store';

type GetUserId = () => number | undefined;
export const getUserId: GetUserId = () => {
  const userId = getDecodedUserId() ?? '';

  const id = parseInt(userId);

  if (isNaN(id)) {
    return undefined;
  }

  return id;
};
